{
	"access": {
		"ability": {
			"admins_manage": "Gestione admin",
			"call_manage": "Gestire il bando",
			"call_monitor": "Seguire i bandi e sollecitare i gestori",
			"email_texts_manage": "Modificare i testi delle email",
			"event_log_read": "Leggere il registro degli eventi",
			"residences_manage": "Gestire le strutture",
			"sending_monitor": "Seguire gli invii e le anomalie",
			"support_manage": "Assistere gli studenti",
			"users_manage": "Gestione utenti"
		},
		"copy_user_id": "Copia ID utente",
		"no_permissions": "Nessun permesso",
		"permissions": "Permessi",
		"sign_in_method": "Metodo di accesso",
		"source": {
			"invite_accept": "Invito",
			"password": "Password",
			"password_reset": "Reset password"
		},
		"title": "Accesso",
		"user_id": "ID utente"
	},
	"account": {
		"email_field": {
			"change_success": "Il tuo indirizzo email è stato aggiornato.",
			"code_sent_new": "Abbiamo inviato un codice di verifica a {{email}}.",
			"codes_sent_both": "Abbiamo inviato un codice a {{currentEmail}} e a {{email}}.",
			"confirm_button": "Conferma cambio email",
			"current_code_label": "Codice dalla tua email attuale",
			"new_code_label": "Codice dalla nuova email",
			"validation": {
				"invalid": "Inserisci un indirizzo email valido.",
				"unchanged": "Inserisci un'email diversa da quella attuale."
			}
		},
		"personal_data": {
			"name_max": "Il nome può contenere al massimo 100 caratteri.",
			"name_required": "Inserisci il tuo nome."
		},
		"update_success": "Profilo aggiornato con successo."
	},
	"security": {
		"access": {
			"change_email": "Cambia email",
			"description": "Aggiorna la password usata per accedere al tuo account.",
			"error": "Aggiornamento della password non riuscito. Riprova.",
			"otp_hint": "Ti invieremo un codice via email per autorizzare il cambio password.",
			"submit": "Aggiorna password",
			"success": "Password aggiornata con successo.",
			"title": "Accesso",
			"two_factor": {
				"email_code_sent": "Codice di verifica inviato. Controlla la tua casella di posta.",
				"email_resend_code": "Invia di nuovo il codice",
				"email_send_code": "Invia codice",
				"verify": "Verifica",
				"verify_label": "Codice di verifica"
			},
			"validation": {
				"max": "La password può contenere al massimo 255 caratteri."
			}
		},
		"email": {
			"title": "Email"
		},
		"password": {
			"title": "Password"
		},
		"sessions": {
			"current_badge": "Questo dispositivo",
			"description": "Controlla i dispositivi attualmente connessi al tuo account e revoca quelli che non riconosci.",
			"empty": "Nessuna sessione attiva trovata.",
			"error": "Caricamento delle sessioni non riuscito.",
			"revoke": "Disconnetti",
			"revoke_success": "Dispositivo disconnesso.",
			"signed_in": "Accesso il {{date}}",
			"title": "Sessioni attive",
			"unknown_device": "Dispositivo sconosciuto"
		}
	},
	"title": "Profilo"
}
